import React from 'react';
import ActionInProgressStore from '../Stores/ActionInProgressStore';
import ConnectToStores from '../Utilities/Decorators/ConnectToStoresDecorator';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

/*
 * Sets a 'disabled' prop on children, which is either true when an action is
 * in progress, or false when no action is in progress.
*/
class DisableOnActionInProgress extends React.Component {
    static getStores() {
        return [ActionInProgressStore];
    }

    static getPropsFromStores() {
        return {
            actionInProgress: ActionInProgressStore.anyActionInProgress()
        }
    }

    render() {
        return (<div className="inline">
            {
                React.Children.map(this.props.children, child => {
                    if(!child || child.props.disabled || (!this.props.actionInProgress)) {
                        return child;
                    }

                    return React.cloneElement(child, {
                        disabled: this.props.actionInProgress
                    });
                })
            }
        </div>);
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores);

export default withDecorators(DisableOnActionInProgress);
